export const webchatClasses = {
  container: {
    className: 'bpReset bpContainer bpFont',
    dropzone: {
      overlay: {
        className: 'bpDropzoneOverlay',
      },
    },
  },
  loader: {
    className: 'bpReset bpLoader',
  },
  modal: {
    overlay: {
      className: 'bpModalOverlay',
    },
    dialog: {
      container: {
        className: 'bpReset bpModalContainer',
      },
      title: {
        className: 'bpModalTitle',
      },
      description: {
        className: 'bpModalDescription',
      },
      content: {
        container: {
          className: 'bpModalContentContainer',
        },
        textarea: {
          className: 'bpModalContentTextArea',
        },
      },
      button: {
        container: {
          className: 'bpModalButtonContainer',
        },
        confirm: {
          className: 'bpModalButtonConfirm',
        },
        cancel: {
          className: 'bpModalButtonCancel',
        },
      },
    },
  },
  messagePreview: {
    container: {
      className: 'bpMessagePreviewContainer',
    },
    message: {
      className: 'bpMessagePreviewMessage',
    },
    description: {
      className: 'bpMessagePreviewDescription',
    },
    closeButton: {
      className: 'bpMessagePreviewCloseButton',
    },
    avatar: {
      container: {
        className: 'bpMessagePreviewAvatarContainer',
      },
      image: {
        className: 'bpMessagePreviewAvatarImage',
      },
      fallback: {
        className: 'bpMessagePreviewAvatarFallback',
      },
    },
  },
  fab: {
    container: {
      className: 'bpReset bpFabContainer',
    },
    icon: {
      className: 'bpFabIcon',
    },
    image: {
      className: 'bpFabImage',
    },
  },
  notification: {
    container: {
      className: 'bpReset bpNotificationContainer',
    },
    title: {
      className: 'bpNotificationTitle',
    },
    description: {
      className: 'bpNotificationDescription',
    },
    icon: {
      className: 'bpNotificationIcon',
    },
    closeIcon: {
      className: 'bpNotificationCloseIcon',
    },
  },
  header: {
    container: {
      className: 'bpReset bpHeaderContainer bpFont',
    },
    content: {
      container: {
        className: 'bpReset bpHeaderContentContainer',
      },
      title: {
        className: 'bpHeaderContentTitle',
      },
      description: {
        className: 'bpHeaderContentDescription',
      },
      avatar: {
        container: {
          className: 'bpReset bpHeaderContentAvatarContainer',
        },
        image: {
          className: 'bpHeaderContentAvatarImage',
        },
        fallback: {
          className: 'bpHeaderContentAvatarFallback',
        },
      },
      toggleSound: {
        className: 'bpHeaderSoundToggleButton',
      },
      actions: {
        container: {
          className: 'bpReset bpHeaderContentActionsContainer',
        },
        icons: {
          className: 'bpHeaderContentActionsIcons',
        },
      },
    },
    expandedContent: {
      container: {
        className: 'bpReset bpHeaderExpandedContentContainer',
      },
      descriptionItems: {
        container: {
          className: 'bpReset bpHeaderExpandedContentDescriptionItemsContainer',
        },

        icon: {
          className: 'bpHeaderExpandedContentDescriptionItemsIcon',
        },
        text: {
          className: 'bpHeaderExpandedContentDescriptionItemsText',
        },
        link: {
          className: 'bpHeaderExpandedContentDescriptionItemsLink',
        },
      },
      group: {
        className: 'bpHeaderExpandedContentGroup',
      },
    },
    newConversationIcon: {
      className: 'bpHeaderNewConversationIcon',
    },
  },
  composer: {
    wrapper: {
      className: 'bpReset bpComposerWrapper',
    },
    container: {
      className: 'bpReset bpComposerContainer bpFont',
    },
    footer: {
      className: 'bpComposerFooter',
    },
    inputContainer: {
      className: 'bpComposerInputContainer',
    },
    input: {
      className: 'bpComposerInput',
    },
    sendbutton: {
      className: 'bpComposerSendButton',
    },
    uploadButton: {
      className: 'bpComposerUploadButton',
    },
    voiceButton: {
      className: 'bpComposerVoiceButton',
    },
    fileContainer: {
      className: 'bpComposerFileContainer',
    },
    fileWidget: {
      container: {
        className: 'bpComposerFileAttachement',
      },
      loader: {
        className: 'bpComposerFileLoader',
      },
      fileIcon: {
        container: {
          className: 'bpComposerFileIconWrapper',
        },
        icon: {
          className: 'bpComposerFileIcon',
        },
      },
      metadata: {
        container: {
          className: 'bpComposerFileMetadata',
        },
        name: {
          className: 'bpComposerFileName',
        },
        type: {
          className: 'bpComposerFileExtension',
        },
      },
      removeIcon: {
        className: 'bpComposerFileRemoveIcon',
      },
      errorIcon: {
        className: 'bpComposerFileErrorIcon',
      },
      previewImage: {
        className: 'bpComposerFilePreviewImage',
      },
    },
  },
  messageList: {
    scrollDownButton: {
      className: 'bpMessageListScrollDownButton',
    },
    container: {
      className: 'bpReset bpMessageListContainer bpFont',
    },
    viewPort: {
      className: 'bpMessageListViewport',
    },
    marquee: {
      container: {
        className: 'bpReset bpMessageListMarqueeContainer',
      },
      content: {
        className: 'bpMessageListMarqueeContent',
      },
      title: {
        className: 'bpMessageListMarqueeTitle',
      },
      description: {
        className: 'bpMessageListMarqueeDescription',
      },
      avatar: {
        container: {
          className: 'bpReset bpMessageListMarqueeAvatarContainer',
        },
        image: {
          className: 'bpMessageListMarqueeAvatarImage',
        },
        fallback: {
          className: 'bpMessageListMarqueeAvatarFallback',
        },
      },
    },
    headerMessage: {
      className: 'bpMessageListHeaderMessage',
    },
  },
  message: {
    container: {
      className: 'bpReset bpMessageContainer',
    },
    avatar: {
      container: {
        className: 'bpReset bpMessageAvatarContainer',
      },
      image: {
        className: 'bpMessageAvatarImage',
      },
      fallback: {
        className: 'bpMessageAvatarFallback',
      },
    },
    deliveryStatus: {
      className: 'bpMessageDeliveryStatus',
    },
    blocks: {
      text: {
        heading1: {
          className: 'bpMessageBlocksTextHeading1',
        },
        heading2: {
          className: 'bpMessageBlocksTextHeading2',
        },
        heading3: {
          className: 'bpMessageBlocksTextHeading3',
        },
        heading4: {
          className: 'bpMessageBlocksTextHeading4',
        },
        unorderedList: {
          className: 'bpMessageBlocksTextUnorderedList',
        },
        orderedList: {
          className: 'bpMessageBlocksTextOrderedList',
        },
        listItem: {
          className: 'bpMessageBlocksTextListItem',
        },
        link: {
          className: 'bpMessageBlocksTextLink',
        },
        italic: {
          className: 'bpMessageBlocksTextItalic',
        },
        bold: {
          className: 'bpMessageBlocksTextBold',
        },
        text: {
          className: 'bpMessageBlocksTextText',
        },
        image: {
          className: 'bpMessageBlocksTextImage',
        },
        imageError: {
          className: 'bpMessageBlocksTextImageError',
        },
        horizontalRule: {
          className: 'bpMessageBlocksTextHorizontalRule',
        },
        lineBreak: {
          className: 'bpMessageBlocksTextLineBreak',
        },
        input: {
          className: 'bpMessageBlocksTextInput',
        },
        codeBlockContainer: {
          className: 'bpMessageBlocksTextCodeBlockContainer',
        },
        codeBlockTitle: {
          className: 'bpMessageBlocksTextCodeBlockTitle',
        },
        codeBlockCopyIcon: {
          className: 'bpMessageBlocksTextCodeBlockCopyIcon',
        },
        codeBlock: {
          className: 'bpMessageBlocksTextCodeBlock',
        },
        code: {
          className: 'bpMessageBlocksTextCode',
        },
        tableContainer: {
          className: 'bpMessageBlocksTextTableContainer',
        },
        table: {
          className: 'bpMessageBlocksTextTable',
        },
        tableHeader: {
          className: 'bpMessageBlocksTextTableHeader',
        },
        tableData: {
          className: 'bpMessageBlocksTextTableData',
        },
        tableRow: {
          className: 'bpMessageBlocksTextTableRow',
        },
      },
      audio: {
        className: 'bpMessageBlocksAudio',
      },
      image: {
        image: {
          className: 'bpMessageBlocksImageImage',
        },
        placeholder: {
          className: 'bpMessageBlocksImagePlaceholder',
        },
        skeleton: {
          className: 'bpSkeleton',
        },
      },
      video: {
        className: 'bpMessageBlocksVideo',
      },
      location: {
        container: {
          className: 'bpMessageBlocksLocationContainer',
        },
        title: {
          className: 'bpMessageBlocksLocationTitle',
        },
        icon: {
          className: 'bpMessageBlocksLocationIcon',
        },
      },
      file: {
        container: {
          className: 'bpMessageBlocksFileContainer',
        },
        title: {
          className: 'bpMessageBlocksFileTitle',
        },
        icon: {
          className: 'bpMessageBlocksFileIcon',
        },
      },
      row: {
        className: 'bpMessageBlocksRow',
      },
      column: {
        className: 'bpMessageBlocksColumn',
      },
      bubble: {
        container: {
          className: 'bpMessageBlocksBubble',
        },
        feedbackContainer: {
          className: 'bpMessageBlocksBubbleFeedbackContainer',
        },
        feedbackIcon: {
          className: 'bpMessageBlocksBubbleFeedbackIcon',
        },
      },
      carousel: {
        container: {
          className: 'bpMessageBlocksCarouselContainer',
        },
        slidesContainer: {
          className: 'bpMessageBlocksCarouselSlidesContainer',
        },
        backButton: {
          className: 'bpMessageBlocksCarouselBackButton',
        },
        nextButton: {
          className: 'bpMessageBlocksCarouselNextButton',
        },
      },
      dropdown: {
        button: {
          container: {
            className: 'bpMessageBlocksDropdownButtonContainer',
          },
          text: {
            className: 'bpMessageBlocksDropdownButtonText',
          },
          icon: {
            className: 'bpMessageBlocksDropdownButtonIcon',
          },
        },
        content: {
          container: {
            className: 'bpMessageBlocksDropdownContentContainer',
          },
          item: {
            className: 'bpMessageBlocksDropdownContentItem',
          },
        },
      },
      button: {
        className: 'bpMessageBlocksButton',
      },
    },
  },
  error: {
    container: {
      className: 'bpReset bpErrorContainer',
    },
    id: {
      className: 'bpErrorId',
    },
    header: {
      container: {
        className: 'bpErrorHeader',
      },
      actions: {
        className: 'bpErrorHeaderActions',
      },
    },
    content: {
      className: 'bpErrorContent',
    },
    errorTitle: {
      className: 'bpErrorTitle',
    },
    errorMessage: {
      className: 'bpErrorMessage',
    },
    icon: {
      className: 'bpErrorIcon',
    },
  },
  typingIndicator: {
    container: {
      className: 'bpTypingIndicatorContainer',
    },
    loader: {
      className: 'bpTypingIndicatorLoader',
    },
  },
  proactiveBubble: {
    container: {
      className: 'bpProactiveBubbleContainer',
    },
    content: {
      className: 'bpProactiveBubbleContent',
    },
    layout: {
      className: 'bpProactiveBubbleLayout',
    },
    icon: {
      className: 'bpProactiveBubbleIcon',
    },
    message: {
      className: 'bpProactiveBubbleMessage',
    },
    closeButton: {
      className: 'bpProactiveBubbleCloseButton',
    },
    arrow: {
      className: 'bpProactiveBubbleArrow',
    },
  },
} as const
